import { ElMessage, ElMessageBox } from 'element-plus'
import { resolveAppPath } from '@/utils/appPath'

/**
 * AI 修图额度不足文案里的「充值套餐」做成可跳转链接。
 */
export function resolveRechargePackagesHref (router) {
  try {
    const href = router?.resolve?.({ name: 'RechargePackages' })?.href
    if (href) return href
  } catch { /* 路由未注册时走默认 path */ }
  return resolveAppPath('/dashboard/recharge-packages')
}

export function escapeHtml (value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

let rechargePackClicksBound = false

function bindRechargePackLinkClicks () {
  if (rechargePackClicksBound || typeof document === 'undefined') return
  rechargePackClicksBound = true
  document.addEventListener('click', (event) => {
    const link = event.target?.closest?.('a.ai-quota-recharge-link')
    if (!link) return
    event.preventDefault()
    const href = link.getAttribute('href') || resolveAppPath('/dashboard/recharge-packages')
    try {
      ElMessageBox.close()
    } catch { /* 当前没有 MessageBox */ }
    import('@/router')
      .then((mod) => mod.default.push({ name: 'RechargePackages' }))
      .catch(() => {
        window.location.assign(href)
      })
  })
}

export function linkifyRechargePackHint (escapedHtml, href) {
  bindRechargePackLinkClicks()
  const safeHref = String(href || resolveAppPath('/dashboard/recharge-packages')).replace(/"/g, '&quot;')
  const link = `<a href="${safeHref}" class="ai-quota-recharge-link" style="color:#409eff;text-decoration:underline;">充值套餐</a>`
  return String(escapedHtml || '')
    .replace(/「充值套餐」/g, `「${link}」`)
    .replace(/【充值套餐】/g, `【${link}】`)
}

/** 额度不足等接口错误：把「充值套餐」做成可点链接 */
export function notifyQuotaAwareError (message) {
  const text = typeof message === 'string' && message.trim() ? message.trim() : '操作失败，请稍后重试'
  const html = linkifyRechargePackHint(escapeHtml(text), resolveRechargePackagesHref())
  const run = () => {
    if (html.includes('ai-quota-recharge-link')) {
      ElMessage({
        type: 'error',
        dangerouslyUseHTMLString: true,
        message: html,
        duration: 8000
      })
      return
    }
    ElMessage.error(text)
  }
  if (typeof queueMicrotask === 'function') {
    queueMicrotask(run)
  } else {
    setTimeout(run, 0)
  }
}
